"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KioskHeartbeatRequestStruct = void 0;
const superstruct_1 = require("superstruct");
exports.KioskHeartbeatRequestStruct = (0, superstruct_1.type)({
    placeId: (0, superstruct_1.string)(),
    kioskCode: (0, superstruct_1.string)(),
    sessionId: (0, superstruct_1.string)(),
});
//# sourceMappingURL=KioskHeartbeatRequest.js.map